import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/50 via-background-50 to-accent-50/30 pointer-events-none"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-[72px] pb-12 md:pb-0">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-8 lg:pt-0">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-5 whitespace-nowrap">
              {heroData.tag}
            </span>

            <h1 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-foreground-950 font-heading leading-tight mb-3">
              {heroData.h1}
            </h1>

            <p className="text-base md:text-lg text-primary-600 font-medium mb-6">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-7">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-lg md:text-xl font-bold text-foreground-950 font-heading">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleClick(heroData.primaryCta.href)}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                {heroData.primaryCta.text}
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button
                onClick={() => handleClick(heroData.secondaryCta.href)}
                className="w-full sm:w-auto px-8 py-3 bg-background-100 hover:bg-background-200 text-foreground-800 font-semibold rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer border border-background-300"
              >
                <i className="ri-download-line mr-2"></i>
                {heroData.secondaryCta.text}
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg xl:max-w-xl aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20scene%20with%20warm%20crimson%20and%20amber%20lighting%2C%20abstract%20composite%20of%20breaking%20news%20elements%2C%20digital%20interface%20fragments%2C%20hot%20topic%20labels%20floating%2C%20dark%20atmospheric%20background%20with%20subtle%20texture%2C%20modern%20editorial%20design%2C%20high%20contrast%2C%20intriguing%20and%20mysterious%20mood%2C%20professional%20photo%20manipulation%20style%20with%20clean%20composition&width=800&height=600&seq=hero-visual-01&orientation=landscape"
                alt="91黑料网 - 一站式吃瓜爆料平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <span className="px-3 py-1 bg-primary-500 text-white text-xs font-medium rounded-full">实时更新</span>
                <span className="px-3 py-1 bg-accent-500/90 text-white text-xs font-medium rounded-full">7×24h</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}